module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_kf_nor.3e0a0171.png";